module.exports = __webpack_public_path__ + "img/9788958282891.91ec251c.jpg";